import {createFileRoute} from '@tanstack/react-router';
import {HomeLayout} from '@features/flow/components/HomeLayout';
import {ChangelogView} from '@features/flow/components/ChangelogView';

export const Route = createFileRoute('/whats-new')({component: WhatsNewPage});

function WhatsNewPage() {
  return (
    <HomeLayout currentView='changelog'>
      <title>Banani | What's new</title>
      <ChangelogView />
    </HomeLayout>
  );
}
